import { getRegisterFunction } from '../../utils/register.js';
import { OneUxIndicationElement } from './OneUxIndicationElement.js';
export const register = getRegisterFunction(OneUxIndicationElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-indication': OneUxIndicationElement;
    "ux-indication-2529d1c47ec57c544a021aa245915f6e": OneUxIndicationElement;
  }
}